import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { setTeamName } from '../store/teamSlice';
import './TeamNameEditor.css';

const TeamNameEditor: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentTeamName = useSelector((state: RootState) => state.team.team.name);
  
  const [isEditing, setIsEditing] = useState(false);
  const [teamName, setTeamNameValue] = useState(currentTeamName);
  
  const handleEditClick = () => {
    setIsEditing(true);
    setTeamNameValue(currentTeamName);
  };
  
  const handleSave = () => {
    if (teamName.trim()) {
      dispatch(setTeamName(teamName.trim()));
      setIsEditing(false);
    }
  };
  
  const handleCancel = () => {
    setIsEditing(false);
    setTeamNameValue(currentTeamName);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };
  
  return (
    <div className="team-name-editor">
      {isEditing ? (
        <div className="team-name-form">
          <input
            type="text"
            value={teamName}
            onChange={(e) => setTeamNameValue(e.target.value)}
            placeholder="Enter team name"
            className="team-name-input"
            autoFocus
            onKeyDown={handleKeyDown}
          />
          <button className="save-button" onClick={handleSave} disabled={!teamName.trim()}>
            Save
          </button>
        </div>
      ) : (
        <div className="team-name-display" onClick={handleEditClick}>
          <h2>{currentTeamName}</h2>
          <span className="edit-hint">Click to edit</span>
        </div>
      )}
    </div>
  );
};

export default TeamNameEditor; 